<template>
    <div
        id="nav"
        class="wrapcircles"
        :class="{ 'closed': menuClosed }"
    >
        <div
            class="circle c-1"
            :class="{ 'c-1__default': defaultProperties.currentAngle === editProperties.currentAngle }"
            @click="setViewAngle"
        >
            <span>
                <a class="link">
                    <i class="icon icon-map-view"/>
                </a>
                <span class="tooltiptext">
                    Angle de vue
                </span>
            </span>
        </div>
        <div
            class="circle c-2"
            :class="{ 'c-2__default': defaultProperties.currentZoom == editProperties.currentZoom }"
            @click="setZoomLevel"
        >
            <span>
                <a class="link">
                    <i class="icon icon-search"/>
                </a>
                <span class="tooltiptext">
                    Niveau de zoom
                </span>
            </span>
        </div>
        <div
            class="circle c-3"
            :class="{ 'c-3__default': defaultProperties.currentCompass === editProperties.currentCompass }"
            @click="setCompass"
        >
            <span>
                <a class="link">
                    <i class="icon icon-hotspot"/>
                </a>
                <span class="tooltiptext">
                    Boussole
                </span>
            </span>
        </div>
        <div
            id="click"
            class="circle c-4"
            @click="toggleMenu"
        >
            <span>
                <a class="link"/>
            </span>
        </div>
    </div>
</template>

<script>
    import Http from '@/api/data';
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    export default {
        name: 'EditDigitalModel',
        props: [
            'active',
            'data',
            'link',
            'editProperties',
            'defaultProperties'
        ],
        data() {
            return {
                menuClosed: false,
                currentCompass: 0
            }
        },
        computed: {
            ...mapGetters([
                'isReviewUse',
                'protocol'
            ]),
            levelId() {
                return this.data.floors ? 'levels' : this.data.levels.filter(el => el.active)[0].id;
            },
            apiUrl() {
                return this.protocol + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            // TODO: Implémenté test IP
            // console.log(document.referrer);
        },
        methods: {
            toggleMenu() {
                this.menuClosed = !this.menuClosed;
            },
            setViewAngle() {
                if (this.defaultProperties.currentAngle !== this.editProperties.currentAngle) {
                    this.defaultProperties.currentAngle = this.editProperties.currentAngle;
                    let data = {
                        angle : this.editProperties.currentAngle,
                        level : this.levelId,
                    }
                    this.saveMetadata(data);
                }
            },
            setZoomLevel() {
                if (this.defaultProperties.currentZoom !== this.editProperties.currentZoom) {
                    this.defaultProperties.currentZoom = this.editProperties.currentZoom;
                    let data = {
                        level : this.levelId,
                        zoom : this.editProperties.currentZoom,
                    }
                    this.saveMetadata(data);
                }
            },
            setCompass() {
                if (this.defaultProperties.currentCompass !== this.editProperties.currentCompass) {
                    this.defaultProperties.currentCompass = this.editProperties.currentCompass;
                    let data = {
                        level : this.levelId,
                        north : this.editProperties.currentCompass,
                    }
                    this.saveMetadata(data);
                }
            },
            saveMetadata(data) {
                let urlLink = this.apiUrl + '/save/' + this.data.contentItemId;
                Http.postDataForm(urlLink, data).then(payload => {
                    console.log(payload);
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            }
        },
        watch: {
            link() {
                if (this.active) {
                    if (this.editProperties.currentCompass !== null)
                        this.defaultProperties.currentCompass = this.editProperties.currentCompass;
                }
            },
            'editProperties.currentAngle'(val) {
                this.editProperties.currentCompass = val;
            }
        }
    }
</script>

<style lang="scss" scoped>
    $radius: 10em;
    .circle {
        position: absolute;
        top: 0;
        right: 0;
        width: $radius;
        height: $radius;
        transition: width 0.3s, height 0.3s, transform 0.3s;
        transform-origin: top right;
        border-bottom-left-radius: 100%;

        .link {
            width: 100%;
            height: 100%;
            display: block;

            > i {
                position: absolute;
                bottom: .7em;
                right: .7em;
                color: white;
                font-weight: bold;
                font-size: 25px;
            }
        }

        .link::before {
            position: absolute;
            display: block;
            color: white;
            // font-family: 'FontAwesome';
            font-size: 1.5em;
            top: .6em;
            right: .6em;
        }
    }
    .wrapcircles.closed{
        .circle {
            transform: rotate(90deg);
            width: $radius / 3;
            height: $radius / 3;
            transition-delay: 0s;
        }

        #click {
            transform: none;
            transition: all 0.3s;

            > span {
                top: .5em;
                right: .5em;

                &::after {
                    transform: rotate(90deg);
                }

                &::before {
                    transform: none;
                }
            }
        }
    }
    #click {
        cursor: pointer;
    }
    #click > span {
        transition: bottom 0.3s, left 0.3s;
        display: block;
        width: 30px;
        height: 30px;
        top: 7.5em;
        right: .8em;
        position: absolute;

        &::before, &::after{
            display: block;
            position: absolute;
            font-family: inherit;
            content: '';
            width: 30px;
            height: 8px;
            transition: transform 0.3s;
            top: 11px;
            border-radius: 3px;
            background: white;
        }

        &::before {
            transform: rotate(-45deg);
        }

        &::after{
            transform: rotate(45deg);
        }
    }
    .c-1 {
        z-index: 1;
        cursor: pointer;
        transition-delay: 0.1s, 0.1s, 0.1s;
        transform: rotate((90deg/4) * 1);
        background: #afafaf;

        &__default {
            background: #43A047;
            cursor: default;
        }

        i {
            transform: rotate((90deg/4) * -1);
        }

        &:hover .tooltiptext {
            visibility: visible;
            opacity: 1;
            background-color: #43A047;
            top: 15em;
            right: 2em;
            transform: rotate((90deg/4) * -1);
        }
    }
    .c-2 {
        z-index: 1;
        cursor: pointer;
        transition-delay: 0.2s, 0.2s, 0.2s;
        transform: rotate((90deg/4) * 2);
        background: #969696;

        &__default {
            background: #388E3C;
            cursor: default;
        }

        i {
            transform: rotate((90deg/4) * -2);
        }

        &:hover .tooltiptext {
            visibility: visible;
            opacity: 1;
            background-color: #388E3C;
            top: 16em;
            right: 2em;
            transform: rotate((90deg/4) * -2);
        }
    }
    .c-3 {
        z-index: 1;
        cursor: pointer;
        transition-delay: 0.3s,0.3s, 0.3s;
        transform: rotate((90deg/4) * 3);
        background: #7d7d7d;

        &__default {
            background: #2E7D32;
            cursor: default;
        }

        i {
            transform: rotate((90deg/4) * -3);
        }

        &:hover .tooltiptext {
            visibility: visible;
            opacity: 1;
            background-color: #2E7D32;
            top: 15.5em;
            right: 1em;
            transform: rotate((90deg/4) * -3);
        }
    }
    .c-4 {
        background: #4CAF50;
        z-index: 0;
    }
    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }

    .tooltiptext {
        visibility: hidden;
        color: color('shades', 'white');
        text-align: center;
        padding: 5px 15px;
        font-size: 14px;
        opacity: 0;
        transition: opacity .5s;
        position: absolute;
        top: 100%;
        transform: translate(-15%, -40%);
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/navbarLayout/editMode/EditDigitalModel.vue